// extracted by mini-css-extract-plugin
export default {"tableContainer":"ProductDetailsTable_tableContainer__aKqs-"};